import { Link } from 'react-router-dom';
import { articleList } from '@/mocks/articles';

export default function ArticlesSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4 whitespace-nowrap">
            Expert Guides
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4 text-balance">
            Vigorbuy Spreadsheet Guides & Resources
          </h2>
          <p className="text-foreground-500 text-base max-w-2xl mx-auto">
            Explore our collection of in-depth <strong>vigorbuy spreadsheet</strong> guides covering product discovery, safety tips, category breakdowns, and expert shopping strategies for 2026.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articleList.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-300 overflow-hidden"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={article.imageSrc}
                  alt={article.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-white/85 backdrop-blur-sm text-foreground-800 text-xs font-medium whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="flex flex-col flex-1 p-5">
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2 flex-1">
                  {article.description}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.readTime}</span>
                  <span className="flex items-center gap-1 text-accent-600 font-medium group-hover:gap-2 transition-all whitespace-nowrap">
                    Read More <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-accent-600 hover:text-accent-700 font-medium transition-colors whitespace-nowrap"
          >
            Back to Home <i className="ri-arrow-left-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}